import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './CommonHowitworks.css';

import Footer from "../../Footer";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import Image from 'react-bootstrap/Image';
import { Link,useNavigate } from 'react-router-dom';
import Topbar from "../../Topbar";

const CommonHowitworks = () => {
const navigate = useNavigate();
const [loading,setLoading] = useState(true);
const [howitworks, setHowitworks] = useState('<p></p>');
const [img, setImg] = useState('');

    useEffect(() => {
        document.title = `How It Works | Local Bells`;
        document.getElementById('bodywrap').className = 'cneprivacy';

        /* Start get how it works */
        let formData = new FormData();
        formData.append('type', 'how_it_works');
            API.post('get_page', formData)
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setImg(response.data.data.image);
                  setHowitworks(response.data.data.content);
                }                  
            }).catch(error => {
                  setLoading(false);
            });  
        /* End get how it works */
    }, []);

    return (
        <>
            <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <Col md={12} lg={12} xl={12} xxl={12} className='main-cont-box-right'>
                            <div className='nei-cont'>
                                <div className='white-box static-cont'>
                                    <Row>
                                        <Col>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>How It Works</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row className=''>
                                        {img && (
                                        <Col xs={12} className="mb-4">
                                            <Image
                                              src={img}
                                              className="img-fluid "
                                              alt="wp"
                                            />
                                        </Col>
                                        )}
                                        <Col xs={12}>
                                            <div dangerouslySetInnerHTML={{__html: howitworks}} />
                                        </Col>
                                    </Row>
                                </div>
                                                             
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
            )}  
        </>
    )
}

export default CommonHowitworks;


